<template>
  <Modal v-model="domesticCourierSelectModal" :title="$t('key1004262')" width="500" :transfer="false"
    :mask-closable="false" @on-visible-change="domesticCourierSelectChange">
    <Form ref="domesticCourierSelectForm" :model="domesticCourierSelectForm" :rules="ruleValidate" :label-width="90" @submit.native.prevent>
      <Row style="width:90%">
        <h2 class="crimsonRedColor mb8 ml30">{{ $t('key1004265') }}</h2>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item class="radio_styles" :label="$t('key1004263')" prop="orderMethd">
            <RadioGroup v-model="domesticCourierSelectForm.orderMethd" @on-change="placeTypeChange">
              <Radio :label="1">{{ $t('key1004266') }}</Radio>
              <Radio :label="2">{{ $t('key1004267') }}</Radio>
            </RadioGroup>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-show="domesticCourierSelectForm.orderMethd === 1">
          <Form-item :label="$t('key1004264')" prop="shippingMethodId">
            <Select v-model="domesticCourierSelectForm.shippingMethodId" filterable transfer>
              <Option v-for="(item, index) in domesticExpressDeliveryList" :value="item.shippingMethodId" :key="index">{{ item.name }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-show="domesticCourierSelectForm.orderMethd === 2">
          <Form-item :label="$t('key1001579')" prop="expressageCode">
            <Select v-model="domesticCourierSelectForm.expressageCode" filterable transfer>
              <Option v-for="(item, index) in typeShippingList" :value="item.code" :key="index">{{ item.name }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-show="domesticCourierSelectForm.orderMethd === 2">
          <Form-item :label="$t('key1001580')" prop="expressageNo">
            <Input clearable v-model.trim="domesticCourierSelectForm.expressageNo"></Input>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <div style="text-align: right;">
        <Button @click="domesticCourierSelectModal = false">{{ $t('key1000112') }}</Button>
        <Button type="primary" @click="endPackingBtn">{{ $t('key1004012') }}</Button>
      </div>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import {getQueryCarrierShippingName, getYunLogisticsAll} from "@/utils/common";

export default {
  name: "domesticCourierSelectModal",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      domesticCourierSelectModal: false,
      domesticCourierSelectForm: {
        orderMethd: 1, // 下单类型
        shippingMethodId: null, // 国内快递
        expressageCode: null, // 物流商
        expressageNo: '', // 物流单号
      },
      ruleValidate: {
        shippingMethodId: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004261'), trigger: 'change'}
        ],
        expressageCode: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001569'), trigger: 'change'}
        ],
        expressageNo: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001570'), trigger: 'blur'}
        ]
      },
      typeShippingList: [],
      domesticExpressDeliveryList: [],
    };
  },
  created() {

  },
  methods: {
    // 初始化数据
    initDomesticCourierSelectData() {
      this.getExpressageHundredList();
      this.getDomesticExpressDeliveryData();
      this.domesticCourierSelectModal = true;

    },
    // 下单方式
    placeTypeChange(value) {
      this.domesticCourierSelectForm.shippingMethodId = null;
      this.domesticCourierSelectForm.expressageCode = null;
      this.domesticCourierSelectForm.expressageNo = '';
    },
    // 获取运输方式的数据
    getExpressageHundredList() {
      let v = this;
      v.typeShippingList = [];
      v.axios.get(api.get_expressageHundred_query + '?type=kuaidi100').then(response => {
        if (response.data.code === 0) {
          v.typeShippingList = response.data.datas || [];
        }
      });
    },
    // 获取国内快递的基础数据
    async getDomesticExpressDeliveryData() {
      let v = this;
      v.domesticExpressDeliveryList = [];
      let newList = [];
      let shippingMethodIdList = [];
      const logisticsList = await getYunLogisticsAll();
      let newData = logisticsList.filter((item) => {
        return item.channelType === 0 && item.status === 1;
      });
      // 获取云卖物流国内且已启用关联的物流渠道
      if (newData.length > 0) {
        newData.map((ele) => {
          let list = ele.ymsLogisServiceMappingList || [];
          if (list.length > 0) {
            newList.push(...list);
          }
        });
        if (newList.length > 0) {
          newList.map((item) => {
            if (item.shippingMethodId) {
              shippingMethodIdList.push(item.shippingMethodId);
            }
          });
          if (shippingMethodIdList.length > 0) {
            getQueryCarrierShippingName(shippingMethodIdList).then((shippingMethodList) => {
              if (shippingMethodList.length > 0) {
                shippingMethodList.map((item) => {
                  item.name = item.carrierName + ' / ' + item.carrierShippingMethodName;
                });
                v.domesticExpressDeliveryList = shippingMethodList;
              }
            });
          }
        }
      }
    },
    // 结袋按钮
    endPackingBtn() {
      let v = this;
      let validateField = [];
      let type = v.domesticCourierSelectForm.orderMethd;
      if (type === 1) {
        validateField = ['shippingMethodId'];
      } else {
        validateField = ['expressageCode', 'expressageNo'];
      }
      Promise.all(validateField.map(field => {
        const promise = new Promise(function (resolve, reject) {
          v.$refs['domesticCourierSelectForm'].validateField(field, (error) => {
            resolve(error);
          });
        });
        return promise;
      })).then((data) => {
        if (data.every(i => !i)) {
          v.$emit('updateEndPacking', v.domesticCourierSelectForm);
        }
      });
    },
    // 监听弹窗
    domesticCourierSelectChange(value) {
      if (!value) {

      }
    }
  }
};
</script>

<style lang="less" scoped>

</style>